import { type SVGProps, forwardRef } from "react";

export const EventIcon = forwardRef<
	SVGSVGElement,
	Omit<SVGProps<SVGSVGElement>, "ref"> & {
		title?: string | undefined;
		titleId?: string | undefined;
	}
>((props, ref) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			aria-hidden={!props.title}
			{...props}
		>
			<title>{props.title || "Event"}</title>
			<circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="2" />
			<path
				d="M11.5825 7.63328C11.7801 7.33353 12.2199 7.33353 12.4175 7.63328L13.6246 9.46452C13.6913 9.56571 13.7925 9.63922 13.9094 9.67139L16.024 10.2536C16.3701 10.3489 16.506 10.7671 16.282 11.0476L14.9134 12.7616C14.8378 12.8563 14.7991 12.9753 14.8047 13.0963L14.9044 15.2874C14.9208 15.646 14.565 15.9045 14.229 15.7781L12.176 15.0062C12.0625 14.9635 11.9375 14.9635 11.824 15.0062L9.77104 15.7781C9.43499 15.9045 9.07924 15.646 9.09558 15.2874L9.19534 13.0963C9.20085 12.9753 9.1622 12.8563 9.08658 12.7616L7.718 11.0476C7.49398 10.7671 7.62987 10.3489 7.976 10.2536L10.0906 9.67139C10.2075 9.63922 10.3087 9.56571 10.3754 9.46452L11.5825 7.63328Z"
				fill="#171717"
			/>
		</svg>
	);
});
